import { render, staticRenderFns } from "./itemsForm.vue?vue&type=template&id=6482d85d&"
import script from "./itemsForm.vue?vue&type=script&lang=js&"
export * from "./itemsForm.vue?vue&type=script&lang=js&"
import style0 from "./itemsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports